const getQueryParam = (queryParamKey: string): string | null =>
  new URLSearchParams(window.location.search).get(queryParamKey);
export default getQueryParam;
